import { ModuleFE_Action } from './ModuleFE_Action.js';
export const ModulePackFE_ActionDB = [ModuleFE_Action];
//# sourceMappingURL=module-pack.js.map